import RecoverStep from "../recover_step";

const TEMPLATE = 'generic-error';

export default class GenericError extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    render(data, el, fr) {
        if ( data.tmp.errorMessage ){
            data.render = {
                errorMessage: data.tmp.errorMessage,
                errorTitle: data.tmp.errorTitle
            };
        }
        else {
            data.render = {};
        }
    }

    transitionTryAgain(data, el, fr) {
        data.loadShare = false;
        fr.goTo(data.tmp.genericError.tryAgain);
    }

    transitionBack(data, el, fr) {
        fr.goTo(data.tmp.genericError.back);
    }
}
